export const HORIZONTAL_SPACING_MOBILE = 1.5;
export const HORIZONTAL_SPACING_DESKTOP = 3.75;
